import {BaseModuleProps} from "../../../infrastructure/models/props/base-module-props";
import {GameCenterWidgetController} from "../game-center-widget.controller";

export class GameCenterWidgetProps extends BaseModuleProps {
  controller: GameCenterWidgetController;
  matchupId: String;
  gameId: Number;
  location: Location;
}
